module.exports = __webpack_public_path__ + "me_logo_dark_big.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pictures/me_logo_dark_big.png
// module id = 306
// module chunks = 0